import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPhoneHome({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3.84.5h.19l.2.04a3 3 0 011.35.67l.2.19c.44.4.8.78 1.17 1.25l-.02-.02c.31.34.53.68.66 1.05.25.73.13 1.47-.37 1.95l-.73.73.07.12.1.16.2.27a15.08 15.08 0 00.68.8c.5.6 1.02 1.17 1.57 1.7l.46.43.05.04.83-.55a2.1 2.1 0 012.06.03c.32.2.54.4.91.8l.05.05c.46.5.85 1.03 1.14 1.56l.14.3a2 2 0 01.24 1.08l-.02.13c-.04.46-.24.85-.58 1.14-.13.12-.27.23-.42.32l-.36.19c-.6.3-1.28.5-1.95.52h-.26c-.49 0-.94-.06-1.44-.2-1.66-.46-3.34-1.64-5.12-3.6a21.94 21.94 0 01-2.1-2.74l-.5-.8A7.42 7.42 0 011 4.84a5 5 0 01.14-1.64c.15-.57.48-1.17.93-1.7l.23-.27c.06-.07.13-.13.23-.2l.22-.18.13-.1c.24-.13.5-.22.79-.24L3.84.5zm.03 1.67h-.09l-.1.06-.09.09-.15.14a3.01 3.01 0 00-.79 2.34c.08.9.42 1.72 1.15 2.88a21.66 21.66 0 002.27 3c1.59 1.74 3 2.76 4.35 3.12.42.13.81.18 1.16.15a3.62 3.62 0 001.7-.65c.07-.06.08-.08.08-.14 0-.19-.07-.4-.22-.67a9.49 9.49 0 00-.62-.87l-.16-.2-.17-.24-.22-.22-.13-.13a.64.64 0 00-.12-.1 1.36 1.36 0 00-.33-.09h-.03l-.97.65c-.22.13-.48.2-.75.2-.34 0-.65-.1-.95-.3l-.14-.1-.4-.35c-.43-.4-.86-.84-1.32-1.36l-.28-.32-.35-.42-.2-.22-.45-.54-.14-.2-.3-.38a2.47 2.47 0 01-.3-.6c-.13-.39-.09-.72.11-1l.09-.11.08-.09.26-.25.73-.73s0-.18-.04-.31a.45.45 0 00-.05-.1l-.03-.05-.05-.07-.21-.26-.08-.11c-.4-.5-.78-.88-1.1-1.13a2.1 2.1 0 00-.47-.27l-.1-.04-.08-.01z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPhoneHome.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPhoneHome.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicPhoneHome svgRef={ref} {...props} />);
export default ForwardRef;
